import { render, staticRenderFns } from "./NavDetai.vue?vue&type=template&id=0b818544&scoped=true"
import script from "./NavDetai.vue?vue&type=script&lang=js"
export * from "./NavDetai.vue?vue&type=script&lang=js"
import style0 from "./NavDetai.vue?vue&type=style&index=0&id=0b818544&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b818544",
  null
  
)

export default component.exports